module.exports = __webpack_public_path__ + "img/chat.2e83b100.svg";